export const DOWNLOAD_STATES = {
  IDLE: 0,
  PENDING: 1,
  IN_PROGRESS: 2,
}
export const INVALID_WIDTH_MESSAGE = 'Width must be a valid number (positive number, maximum 3 decimal points)';
export const INVALID_HEIGHT_MESSAGE = 'Height must be a valid number (positive number, maximum 3 decimal points)';
export const INVALID_WIDTH_AND_HEIGHT_MESSAGE = 'Width and Height must be valid numbers (positive number, maximum 3 decimal points)';

export const NUMBER_REGEX_WITH_THREE_DECIMALS = /^\d*\.?\d{1,3}$/;

// Customers Canvas product resizing options
// Ref: https://customerscanvas.com/docs/cc/customerscanvas.iframeapi.commands.resizerectangletype.htm
// ORIGINAL - Expands only the canvas. Items remain in their places in the center of the expanded canvas
// ARBITRARY - Applies an arbitrary resize to items to fit them into the resulting bounding rectangle
export const ResizeRectangleType = {
  ARBITRARY: 2,
  ORIGINAL: 3,
};

export const INCH_IN_POINTS = 72;
export const PRINT_BLEED = 0.125; // in inches

export const PROOF_MAX_HEIGHT = 5000;
export const PROOF_MAX_WIDTH = 5000;